import DailyScheduleService from "./DailyScheduleService";
import { shiftDateKey, todayDate } from "./data";

/**
 * The patient's CURRENT routine, for readers outside this section — the health
 * plan's routine times and its profile panel.
 *
 * Since ZY-10330 the schedule is one document per calendar DAY, so "the
 * patient's schedule" has to pick a day: today's if it is filled, else the
 * newest filled day before today — the day the section itself opens on. A day
 * in the future is never "current", hence the `before` bound (exclusive, so
 * tomorrow's key keeps today in range).
 *
 * Answers that day's ListResponse. A patient who has never filled a day gets
 * today's, which comes back `filled: false` with no entries — readers go by
 * `filled`, the only signal that the rows are the patient's.
 */
const readLatestSchedule = (patientId, onResponse, onError) => {
  const svc = new DailyScheduleService();
  const today = todayDate();
  return svc.days(
    patientId,
    { limit: 1, before: shiftDateKey(today, 1) },
    (res) => {
      const newest = res && Array.isArray(res.items) && res.items[0];
      svc.list(patientId, (newest && newest.date) || today, onResponse, onError);
    },
    onError
  );
};

export default readLatestSchedule;
